<div class="title-block">
	{{breakName}} Break
</div>
<div class="bottom-lunch-block">
	<div class="timer-block">
		<div class="break-block">
			<div class="minutes">
				<span *ngIf="breakType === 'UNPAID'">
					30 minutes
				</span>
				<span *ngIf="breakType === 'PAID'">
					10 minutes
				</span>
			</div>
			<div class="break-span {{breakType}}-break">
				{{breakType}} BREAK
			</div>
		</div>
		<div class="timer">
			{{breakTimeString$ | async}}
		</div>
	</div>
	<div class="button-block {{breakType}}-break">
		<div><button mat-button [tabindex]="-1" (click)="endBreak()" class="break-button"
				[ngClass]="{'disabled-button': !this.userCoordinates}"
				[disabled]="!this.userCoordinates">End Break</button></div>
	</div>
</div>